// Major Southern Ontario cities/municipalities used in the rental Tickets city
// dropdown. Custom cities added by users are stored in the backend (ticket_cities)
// and merged with this list at runtime.
export const ONTARIO_CITIES = [
  // Greater Toronto Area
  "Toronto", "Mississauga", "Brampton", "Markham", "Vaughan", "Richmond Hill",
  "Oakville", "Burlington", "Milton", "Halton Hills", "Caledon", "Aurora",
  "Newmarket", "King City", "Whitchurch-Stouffville", "Georgina",
  // Durham Region
  "Pickering", "Ajax", "Whitby", "Oshawa", "Clarington (Bowmanville)", "Uxbridge",
  // Hamilton / Niagara
  "Hamilton", "St. Catharines", "Niagara Falls", "Welland", "Grimsby", "Lincoln",
  "Fort Erie", "Niagara-on-the-Lake",
  // Waterloo / Wellington / Southwest
  "Kitchener", "Waterloo", "Cambridge", "Guelph", "Brantford", "Woodstock",
  "London", "Stratford", "Sarnia", "Windsor", "Chatham",
  // Simcoe / Central
  "Barrie", "Innisfil", "Bradford", "Orillia", "Collingwood", "Wasaga Beach",
  "Midland", "Orangeville",
  // Eastern Ontario edge
  "Kingston", "Belleville", "Peterborough", "Cobourg", "Port Hope",
];
